import { AbstractControl } from '@angular/forms';

export function eliminaDuplicados(array: any[], keys: string[], sort: boolean = true): any[] {
  const arrayAux: any[] = [];

  for (let i = 0; i < array.length; i++) {
    const element = array[i];

    let seRepite = false;
    for (let z = i + 1; z < array.length; z++) {
      const element2 = array[z];

      if (compareObj(element, element2, keys)) {
        seRepite = true;
        break;
      }
    }
    if (!seRepite) {
      arrayAux.push(element);
    }
  }

  if (sort) {
    return arrayAux.sort((a, b) => {
      if (a.direccionCompleta > b.direccionCompleta) {
        return 1;
      }
      if (a.direccionCompleta < b.direccionCompleta) {
        return -1;
      }
      return 0;
    });
  } else {
    return arrayAux;
  }
}


function compareObj(a: any, b: any, keys: string[]) {
  for (let i = 0; i < keys.length; i++) {
    if (a[keys[i]] !== b[keys[i]]) {
      return false;
    }
  }
  return true;
}

export function isVacio(valor: any) {
  return (
    valor === '' ||
    valor === undefined ||
    valor === 'undefined' ||
    valor === null ||
    valor === 'null' ||
    valor.length === 0
  );
}

export function rutValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const rut = control.value;
  const rexp = new RegExp(/^([0-9])+\-([kK0-9])+$/);

  if (rut === null) {
    return { rutMalo: true };
  }

  if (rut.match(rexp)) {
    const RUT = rut.split('-');
    const elRut = RUT[0];
    let factor = 2;
    let suma = 0;
    let dv: string;
    for (let i = elRut.length - 1; i >= 0; i--) {
      factor = factor > 7 ? 2 : factor;
      // tslint:disable-next-line: radix
      suma += parseInt(elRut[i]) * factor++;
    }
    dv = (11 - (suma % 11)).toString();
    if (dv === '11') {
      dv = '0';
    } else if (dv === '10') {
      dv = 'k';
    }

    if (dv === RUT[1].toLowerCase()) {
      return null;
    } else {
      return { rutMalo: true };
    }
  } else {
    return { rutMalo: true };
  }
}

export function rutPersonaValidator(control: AbstractControl): { [key: string]: boolean } | null {
  const rut = control.value;
  const rexp = new RegExp(/^([0-9])+\-([kK0-9])+$/);

  if (rut === null) {
    return { rutMalo: true };
  }

  if (rut.match(rexp)) {
    const RUT = rut.split('-');
    const elRut = RUT[0];

    if (elRut < 50000000) {
      return null;
    } else {
      return { rutMalo: true };
    }
  } else {
    return { rutMalo: true };
  }
}

export function convertBase64ToBlobData(base64Data: string, contentType: string = 'image/png', sliceSize = 512) {
  const byteCharacters = atob(base64Data);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);

    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);

    byteArrays.push(byteArray);
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
}
